module.exports = __webpack_public_path__ + "static/img/fokus_logo_farbig.01980e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fokus_logo_farbig.png
// module id = 188
// module chunks = 1